import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=571a681a&scoped=true&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=571a681a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a681a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571a681a')) {
      api.createRecord('571a681a', component.options)
    } else {
      api.reload('571a681a', component.options)
    }
    module.hot.accept("./Tooltip.vue?vue&type=template&id=571a681a&scoped=true&", function () {
      api.rerender('571a681a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/Tooltip.vue"
export default component.exports